const STORAGE_KEY = 'tagada-report-preferences';

export type ReportPreferences = {
  pinned: string[];
  lastViewed: Record<string, string>;
};

const emptyPreferences = (): ReportPreferences => ({ pinned: [], lastViewed: {} });

const readPreferences = (accountKey: string): ReportPreferences => {
  if (typeof window === 'undefined') return emptyPreferences();
  const raw = window.localStorage.getItem(`${STORAGE_KEY}:${accountKey}`);
  if (!raw) return emptyPreferences();
  try {
    return JSON.parse(raw) as ReportPreferences;
  } catch {
    return emptyPreferences();
  }
};

const writePreferences = (accountKey: string, prefs: ReportPreferences): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(`${STORAGE_KEY}:${accountKey}`, JSON.stringify(prefs));
};

export const getReportPreferences = (accountKey: string): ReportPreferences =>
  readPreferences(accountKey);

export const toggleReportPin = (accountKey: string, reportId: string): ReportPreferences => {
  const prefs = readPreferences(accountKey);
  const pinned = prefs.pinned.includes(reportId)
    ? prefs.pinned.filter((id) => id !== reportId)
    : [...prefs.pinned, reportId];
  const next = { ...prefs, pinned };
  writePreferences(accountKey, next);
  return next;
};

export const recordReportView = (accountKey: string, reportId: string): ReportPreferences => {
  const prefs = readPreferences(accountKey);
  const next = {
    ...prefs,
    lastViewed: { ...prefs.lastViewed, [reportId]: new Date().toISOString() },
  };
  writePreferences(accountKey, next);
  return next;
};
